import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/business";

export const FAQ = () => (
  <section id="faq" data-testid="faq-accordion" className="section-pad bg-white">
    <div className="container-tn">
      <div className="max-w-3xl">
        <span className="eyebrow">Frequently Asked</span>
        <span className="gold-rule" />
        <h2 className="font-serif text-navy uppercase text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
          Good questions,<br />clear answers.
        </h2>
      </div>

      <div className="mt-12 max-w-3xl">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-navy/10 rounded-md px-5 sm:px-6 bg-white data-[state=open]:border-gold/60 transition-colors"
            >
              <AccordionTrigger
                className="text-left font-serif text-navy uppercase tracking-[0.06em] text-sm sm:text-base font-semibold hover:no-underline py-5"
                data-testid={`faq-trigger-${i}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-mutedink text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
